var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 426.667 426.667"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M379.567,182.386h-35.276c-15.828-65.832-79.182-109.633-150.672-109.633 c-76.896,0-136.118,53.996-144.013,128.256c-20.078,3.858-49.53,28.156-49.53,62.887v41.373h400.063v-43.028h26.478v-36.516 C426.617,199.877,405.41,181.912,379.567,182.386z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.085,
    y: 261.174,
    style: {
      fill: "#3EA69B"
    },
    width: 425.984,
    height: 44.109
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M82.739,194.667c0-43.157,49.612-96.263,110.812-96.263s110.812,53.106,110.812,96.263H82.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M304.362,194.667c0-43.157-49.612-96.263-110.812-96.263v96.263H304.362z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2F4859"
    },
    cx: 105.357,
    cy: 305.248,
    r: 48.666
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5D6DB"
    },
    cx: 105.357,
    cy: 305.248,
    r: 31.62
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A556A"
    },
    cx: 105.357,
    cy: 305.248,
    r: 13.641
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.57,
    y: 202.123,
    style: {
      fill: "#64798A"
    },
    width: 45.235,
    height: 15.445
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.57,
    y: 202.093,
    style: {
      fill: "#3A556A"
    },
    width: 45.235,
    height: 6.046
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.756,
    y: 202.123,
    style: {
      fill: "#64798A"
    },
    width: 45.235,
    height: 15.445
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.756,
    y: 202.093,
    style: {
      fill: "#3A556A"
    },
    width: 45.235,
    height: 6.046
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M402.309,186.718v38.469l24.308,0.538C426.617,225.726,428.917,200.249,402.309,186.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M0.076,261.162h19.088v-42.385C-2.269,239.348,0.076,261.162,0.076,261.162z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2F4859"
    },
    cx: 362.24,
    cy: 305.248,
    r: 48.666
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5D6DB"
    },
    cx: 362.24,
    cy: 305.248,
    r: 31.62
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A556A"
    },
    cx: 362.24,
    cy: 305.248,
    r: 13.641
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.26f67a60.svg";
export { ForwardRef as ReactComponent };